<template>
  <div class="combo-box">
    <div @click="toggle" class="placeholder" :class="{ visible: open }">
      {{ selected >= 0 ? options[selected] : title }}
      <i
        class="material-icons md-arrow"
        :class="{ rotate: open }"
      >keyboard_arrow_down</i>
    </div>
    <div :class="{ options: true, 'show-options': open }">
      <div
        class="option"
        v-for="(dado, index) in options"
        :key="index"
        v-on:click="handleSelect($event, index)"
      >{{ dado }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  props: {
    options: Array,
    title: String
  },
  data: () => ({
    open: false,
    selected: -1
  }),
  methods: {
    toggle() {
      this.open = !this.open;
    },
    handleSelect(ev, i) {
      this.selected = i;
      this.open = false;
      this.$emit("update", i);
    }
  }
};
</script>

<style>
.combo-box {
  display: inline-block;
  background: #37474f;
  background: var(--color-tertiary);
  width: 42rem;
  cursor: pointer;
  user-select: none;
  max-height: 40rem;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 1rem 1.25rem rgba(33, 33, 33, 0.25);
}
.placeholder {
  padding: 1.4rem;
  display: flex;
  justify-content: space-between;
  transition: color 0.2s;
}

.placeholder.visible {
  color: transparent;
  border-bottom: 0.1rem solid #e8eaf6;
  border-bottom: 0.1rem solid var(--font-color);
}

.material-icons.md-arrow {
  position: relative;
  top: 0.2em;
  transition: transform 0.1s;
  color: var(--font-color);
}

.material-icons.rotate {
  transform: rotate(180deg) translateY(0.3rem);
}

.option {
  padding: 1.4rem;
}

.options {
  transform: scaleY(0);
  transform-origin: 0% 0%;
  opacity: 0;
  position: absolute;
  transition: all 0.4s;
}

.options.show-options {
  transform: scaleY(1);
  opacity: 1;
  position: static;
}

.option:hover {
  background: #1e88e5;
  background: var(--color-danger);
}
</style>
